import React, { Fragment, useEffect, useRef, useState } from "react";
import GptLayout from "./gptLayout";
import "../styles/gptSearch.scss";
import "../styles/gptSearchMobileStyle.scss";
import { AiFillAudio, AiFillDislike, AiFillLike } from "react-icons/ai";
import axios from "axios";
import { LuBookmark, LuLoader } from "react-icons/lu";
import { RiVoiceprintFill } from "react-icons/ri";
import GptSidebar from "./gptSidebar";
import { TiArrowUp } from "react-icons/ti";
import { useTour } from "@reactour/tour";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import {
  captainAlphaModal,
  reasoningicon,
  courses,
  currentAffair,
  defaultFemale,
  defaultMale,
  defaultUser,
  doctor,
  englishIcon,
  generalStudyIcon,
  geogrophyIcon,
  historyIcon,
  homeBanner,
  // hideVideo,
  // lamp1,
  // lamp2,
  // lamp3,
  // linkSearch,
  loaderGif,
  logo_mobile,
  markModal,
  mathIcon,
  medicalModal,
  ndaMentorIcon,
  physicalModal,
  physicsicon,
  polity,
  profile_mic,
  profile_mic_active,
  // searchBook,
  spokenEnglish,
  trainer,
} from "../assets/images";
import userService from "../services/userService";
import bookService from "../services/bookService";
import { toast } from "react-toastify";
import { BsPlayCircle } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { userEndPoints } from "../config";
// import Loader from "../reusable/Loader";
import { useAuth } from "alpha-ui";
// import moment from "moment";
import CustomHelmet from "./reusable/Helmet";
import WhatCanDo from "./gptPages/WhatCanDo";
import { HiOutlinePaperAirplane } from "react-icons/hi";
import SSBMentorIcon from "../images/SSBMentorIcon.png";
import CustomButton from "./reusable/CustomButton";
import choiceBlue from "../images/choiceBlue.png";
import choiceOrange from "../images/choiceOrange.png";
import GptChatHeader from "./reusable/GptChatHeader";
import ReactMarkdown from "react-markdown";
import VideoPopup from "./reusable/VideoPopup";
import CustomCalendar from "./reusable/CustomCalender";
import moment from "moment/moment";
import CustomModal from "./reusable/CustomModal";

import { useNotification } from "alpha-ui";
import Loader from "./reusable/Loader";
import ButtonLoader from "./reusable/ButtonLoader";
import {
  captainAlphaWlcmMsg,
  chemistryWlcmMsg,
  coursesWlcmMsg,
  currentAffairsWlcmMsg,
  englishWlcmMsg,
  generalScienceWlcmMsg,
  geographyWlcmMsg,
  histroyWlcmMsg,
  mathsWlcmMsg,
  medicalWlcmMsg,
  physicalWlcmMsg,
  physicsWlcmMsg,
  polityWlcmMsg,
  reasoningWlcmMsg,
  spokenEnglishWlcmMsg,
} from "../static/arrays/welcomeMsg";
import GptBooks from "./gptBooks";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

const GptSearch = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // CURRENT AFFAIRS DATA STATE STARTS AND EDITOR SETTINGS
  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        [{ font: [] }],
        [{ size: ["12px", "14px", "16px", "18px", "20px"] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["link", "image", "img", "video", "data-video-id"],
      ],
    },
    clipboard: {
      matchVisual: false, // Important to fix the mutation error
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "check",
    "color",
    "background",
    "align",
    "link",
    "image",
    "img",
    "video",
    "data-video-id",
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const localToken = localStorage.getItem("ssb-token")
      ? JSON.parse(localStorage.getItem("ssb-token"))
      : {};

    const data = {
      success: true,
      token: token,
    };
    if (!localToken) {
      localStorage.setItem("ssb-token", data);
    }
  }, [location.search]);

  const { showNotification } = useNotification();

  const [searchValue, setSearchValue] = useState("");
  const [placeHolderInput, setPlaceholderInput] = useState(
    ""
    // "Search anything related to SSB"
  );
  const [activeTab, setActiveTab] = useState("");
  const [activeinput, setActiveInput] = useState(false);
  const [outputData, setOutputData] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [pdfFile, setPdfFile] = useState("");
  const [conversationId, setConversationId] = useState("");
  const [gptMic, setGptMic] = useState("");
  const [gptSpeaker, setGptSpeaker] = useState("");
  const [captainImage, setCaptainImage] = useState("");

  const [srchToday, setSrchToday] = useState(false);

  const [welcomeText, setWelcomeText] = useState({});
  const [showExerciseBar, setshowExerciseBar] = useState(false);

  const [showClassCategory, setShowClassCategory] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [initialSearchType, setInitialSearchType] = useState("");
  const [initialQuestion, setInitialQuestion] = useState("");

  const noCategoryWlcmMsg = {
    logoImg: "",
    name: `Hello ${
      auth?.user?.first_name ? auth?.user?.first_name : "Warrior"
    }`,
    tagLine: "",
    description:
      "Let’s gear up for INET Exam prep – choose your classroom and let’s begin the mission!",
    tutorialLink:
      "https://www.youtube.com/embed/9b7jgLFnd5A?si=0UFWgAZZ52vj6pR2",
    startLink: "",
  };

  // ALL BOOK SAVE STATE STARTS
  // const todatDate = new Date();
  // const currentDate = moment(todatDate).format("YYYY-MM-DD");

  const handleVoice = () => {
    setIsListening(true);
    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.maxResults = 10;
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setSearchValue(transcript);
      setIsListening(false);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.start();
  };

  const [disableVideo] = useState(
    () => JSON.parse(localStorage.getItem("videoSrch")) ?? true
  );

  // const handleDisableVideo = () => {
  //   setDisableVideo((prev) => !prev);
  // };

  useEffect(() => {
    localStorage.setItem("videoSrch", JSON.stringify(disableVideo));
  }, [disableVideo]);

  //  NO CATEGORY CHOSEN
  const handleNoCategory = () => {
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("");
    setActiveInput(false);
    setMediaOpen(false);
    setActiveTab("");
    setOutputData([]);
    setWelcomeText(noCategoryWlcmMsg);
  };

  //  POST DATA TO QUESTION API START
  const handleAskQuestion = () => {
    setShowClassCategory(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setSrchToday(false);
    setPlaceholderInput("Ask anything related to INET");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("question");
    setOutputData([]);
    setWelcomeText(captainAlphaWlcmMsg);
  };

  //  POST DATA TO Medical API START
  const handleMedicalQuestion = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to medical");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("medical");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(medicalWlcmMsg);
  };

  //  POST DATA TO General Science API START
  const handleGeneralScience = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to general science");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("general-science");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(generalScienceWlcmMsg);
  };

  //  POST DATA TO Chemistry API START
  // const handleChemistry = () => {
  //   setShowClassCategory(false);
  //   setSrchToday(false);
  //   setInitialSearchType("");
  //   setInitialQuestion("");
  //   setPlaceholderInput("Ask anything related to chemistry");
  //   setActiveInput(true);
  //   setMediaOpen(false);
  //   setActiveTab("chemistry");
  //   setConversationId("");
  //   setOutputData([]);
  //   setWelcomeText(chemistryWlcmMsg);
  // };

  //  POST DATA TO Chemistry API START
  const handleHistory = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to history");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("history");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(histroyWlcmMsg);
  };

  //  POST DATA TO GEOGRAPHY API START
  const handleGeography = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to geography");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("geography");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(geographyWlcmMsg);
  };

  //  POST DATA TO Maths API START
  const handleReasoning = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to reasoning");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("reasoning");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(reasoningWlcmMsg);
  };

  //  POST DATA TO Maths API START
  const handleMaths = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to maths");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("maths");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(mathsWlcmMsg);
  };

  //  POST DATA TO ENGLISH API START
  const handleEnglish = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to english");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("english");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(englishWlcmMsg);
  };

  //  POST DATA TO POLITY API START
  const handlePolity = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setPlaceholderInput("Ask anything related to polity");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("polity");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(polityWlcmMsg);
  };

  //  POST DATA TO Physical API START
  const handlePhysicalQuestion = () => {
    setShowClassCategory(false);
    setInitialSearchType("");
    setInitialQuestion("");
    setSrchToday(false);
    setPlaceholderInput("Ask anything related to physical");
    setActiveInput(true);
    setMediaOpen(false);
    setActiveTab("physical");
    setConversationId("");
    setOutputData([]);
    setShowSearchInput(false);
    setWelcomeText(physicalWlcmMsg);
  };

  //  POST DATA TO SPOKEN ENGLISH API START
  const handleSpokenEnglish = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setMediaOpen(false);
    setActiveTab("spoken-english");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(spokenEnglishWlcmMsg);
  };

  //  POST DATA TO COURSES API START
  const handleCourses = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setMediaOpen(false);
    setActiveTab("courses");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(coursesWlcmMsg);
  };

  //  POST DATA TO CURRENT AFFAIRS API START
  const handleCurrentAffair = () => {
    setShowClassCategory(false);
    setSrchToday(false);
    setMediaOpen(false);
    setActiveTab("current-affair");
    setConversationId("");
    setOutputData([]);
    setWelcomeText(currentAffairsWlcmMsg);
  };

  const handleSearchResult = async (query, multipleChoiceQu) => {
    setIsLoading(true);
    setSearchValue("");
    setSrchToday(true);
    const newEntry = {
      question: searchValue || multipleChoiceQu,
      answer: "Loading...",
    };
    setOutputData((prevData) => [...prevData, newEntry]);
    try {
      // const result = await userService.userChat(searchValue);
      let result;
      if (activeTab === "question") {
        result = await axios.post(
          `https://chat.ssbgpt.in/api/v1/ssb-mentor-chat`,
          {
            inputText: searchValue,
            conversationId,
          }
        );
      }
      if (activeTab === "medical") {
        result = await axios.post(
          `https://chat.ssbgpt.in/api/v1/medical-chat`,
          {
            inputText: searchValue,
            conversationId,
          }
        );
      }
      if (activeTab === "physical") {
        result = await axios.post(
          `https://chat.ssbgpt.in/api/v1/physical-chat`,
          {
            inputText: searchValue || query,
            conversationId,
          }
        );
      }
      if (activeTab === "olq-analysis") {
        result = await axios.post(
          `https://chat.ssbgpt.in/api/v1/olq-analysis-chat`,
          {
            inputText: searchValue || query,
            conversationId,
          }
        );
      }
      if (activeTab === "CPSS" && initialQuestion === "CPSS-A") {
        result = await axios.post(
          `https://chat.ssbgpt.in/api/v1/cpss-query-chat`,
          {
            inputText: searchValue || query,
            conversationId,
          }
        );
      }
      if (activeTab === "CPSS" && initialQuestion === "CPSS-F") {
        result = await axios.post(
          `https://chat.ssbgpt.in/api/v1/cpss-reasoning-chat`,
          {
            inputText: searchValue || query || multipleChoiceQu,
            conversationId,
          }
        );
      }
      // if (!disableVideo) {
      //   var vdResult = await bookService.getVideoSearch(searchValue);
      // }

      if (result) {
        setConversationId(result?.data?.conversation_id);
        // const videoId = vdResult?.data?.video?.url;
        setOutputData((prevData) =>
          prevData.map((entry, index) =>
            index === prevData.length - 1
              ? {
                  ...entry,
                  answer: result?.data?.answer.replace(/Alpha Bot:\s*/g, ""),
                  // url: videoId,
                  // videoTitle: vdResult?.data?.title,
                }
              : entry
          )
        );

        // IN FUNCTION SPEAK FUNCTIONALITY START
        if (gptSpeaker) {
          const speech = new SpeechSynthesisUtterance(result?.data?.answer);
          // speech.lang = "en-IN";
          speech.lang = "en-IN";
          window.speechSynthesis.speak(speech);
          speech.onend = () => {
            setSearchValue("");
            result = "";
          };
        }
        // IN FUNCTION SPEAK FUNCTIONALITY ENDS

        // let updatedList = [...localHistory];
        // const existingEntry = updatedList.find(
        //   (item) => item.dayData === currentDate
        // );

        // if (existingEntry) {
        //   existingEntry.searchData.push({
        //     question: searchValue,
        //     answer: result?.data?.response,
        //     url: videoId,
        //     videoTitle: vdResult?.data?.title,
        //   });
        // } else {
        //   updatedList.push({
        //     dayData: currentDate,
        //     searchData: [
        //       {
        //         question: searchValue,
        //         answer: result?.data?.response,
        //         url: videoId,
        //         videoTitle: vdResult?.data?.title,
        //       },
        //     ],
        //   });
        // }
        // setQuestionList(updatedList);
        // setlocalHistory(updatedList);
        // localStorage.setItem("userHistory", JSON.stringify(updatedList));
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  //  POST DATA TO API ENDS

  const handleMediaOpen = (e) => {
    e.stopPropagation();
    setMediaOpen(!mediaOpen);
  };

  useEffect(() => {
    const handleClickOutside = () => {
      if (mediaOpen) {
        setMediaOpen(false);
      }
    };
    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, [mediaOpen]);

  const handleLinkGenrate = async () => {
    setIsLoading(true);
    setSearchValue("");
    setSrchToday(true);
    const newEntry = { question: searchValue, answer: "Loading..." };
    setOutputData((prevData) => [...prevData, newEntry]);
    try {
      const result = await axios.post(userEndPoints.linkSummarize, {
        input_text: searchValue,
      });

      if (result?.data?.response !== "No input provided") {
        setOutputData((prevData) =>
          prevData.map((entry, index) =>
            index === prevData.length - 1
              ? {
                  ...entry,
                  answer: result?.data?.response.replace(/Alpha Bot:\s*/g, ""),
                }
              : entry
          )
        );

        // const currentDate = moment().format("YYYY-MM-DD");
        // let updatedList = [...questionList];

        // if (
        //   updatedList.length > 0 &&
        //   updatedList[updatedList.length - 1].dayData === currentDate
        // ) {
        //   updatedList[updatedList.length - 1].searchData.push({
        //     question: searchValue,
        //     answer: result?.data?.response,
        //   });
        // } else {
        //   updatedList.push({
        //     dayData: currentDate,
        //     searchData: [
        //       {
        //         question: searchValue,
        //         answer: result?.data?.response,
        //       },
        //     ],
        //   });
        // }
        // setQuestionList(updatedList);
        // setlocalHistory(updatedList);
        // localStorage.setItem("userHistory", JSON.stringify(updatedList));
        setIsLoading(false);
      } else {
        setOutputData((prevData) =>
          prevData.map((entry, index) =>
            index === prevData.length - 1
              ? {
                  ...entry,
                  answer: "Sorry i have no provided data for that",
                }
              : entry
          )
        );
      }
    } catch (error) {
      setIsLoading(false);
      setMediaOpen(false);
    }
  };

  const handleMediaChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPdfFile(file);
    }
  };

  const handlePdfUpload = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", pdfFile);

      const result = await axios.post(userEndPoints.pdfUpload, formData);

      if (result) {
        setOutputData([
          ...outputData,
          { answer: result?.data?.response, question: searchValue },
        ]);
        setIsLoading(false);
        setSearchValue("");
        setPlaceholderInput("Search anything from provided pdf");
        setActiveTab("pdf_srch");
      }
    } catch (error) {
      setIsLoading(false);
      setMediaOpen(false);
    }
  };

  const handlePdfSearchQuestion = async () => {
    setIsLoading(true);
    setSearchValue("");
    setMediaOpen(false);
    setSrchToday(true);
    const newEntry = { question: searchValue, answer: "Loading..." };
    setOutputData((prevData) => [...prevData, newEntry]);
    try {
      const result = await axios.post(userEndPoints.askQuestion, {
        input_text: searchValue,
      });

      if (result) {
        setOutputData((prevData) =>
          prevData.map((entry, index) =>
            index === prevData.length - 1
              ? {
                  ...entry,
                  answer: result?.data?.response.replace(/Alpha Bot:\s*/g, ""),
                }
              : entry
          )
        );
        // const currentDate = moment().format("YYYY-MM-DD");
        // let updatedList = [...questionList];

        // if (
        //   updatedList.length > 0 &&
        //   updatedList[updatedList.length - 1].dayData === currentDate
        // ) {
        //   updatedList[updatedList.length - 1].searchData.push({
        //     question: searchValue,
        //     answer: result?.data?.response,
        //   });
        // } else {
        //   updatedList.push({
        //     dayData: currentDate,
        //     searchData: [
        //       {
        //         question: searchValue,
        //         answer: result?.data?.response,
        //       },
        //     ],
        //   });
        // }
        // setQuestionList(updatedList);
        // setlocalHistory(updatedList);
        // localStorage.setItem("userHistory", JSON.stringify(updatedList));
        setIsLoading(false);
        setPlaceholderInput("Search anything from provided pdf");
        setActiveTab("pdf_srch");
      }
    } catch (error) {
      setIsLoading(false);
      setMediaOpen(false);
    }
  };

  // HANDLE PDF UPLOAD ENDS

  const handleVideoView = (url) => {
    // const videoId = getYouTubeVideoId(url);
    if (url) {
      navigate(`/video?streamId=${url}`);
    }
  };

  // HANDLE VIDEO SEARCH ENDS

  // STEPS FOR GIVING OVERVIEW
  const { currentStep, isOpen } = useTour();

  useEffect(() => {
    if (currentStep === 0 && isOpen) {
      setMediaOpen(true);
    }
  }, [currentStep, isOpen]);

  // SCROLL HER PAGE AFTER EVERY SEARCH STARTS
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current && outputData) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [outputData]);

  // SCROLL HER PAGE AFTER EVERY SEARCH ENDS

  // CHECK USER TODAY SEARCH HISTORY STARTS
  const savedList = localStorage.getItem("userHistory");

  useEffect(() => {
    if (savedList) {
      const data = JSON.parse(savedList);
      if (data === null) {
        setSrchToday(true);
      } else {
        const today = new Date().toISOString().split("T")[0];
        const checkSearchToday = data.some((item) => item.dayData === today);
        const searchHistory = data.find(
          (item) => item.dayData === today
        )?.searchData;
        if (searchHistory) {
          setOutputData(searchHistory);
        }
        setSrchToday(checkSearchToday);
      }
      setQuestionList(data);
    }
  }, [savedList]);

  const handleShowHistory = (date) => {
    const extractedData = questionList
      ?.filter((ele) => ele?.dayData === date)
      .map((item) => item.searchData)
      .flat();
    setOutputData(extractedData);
  };

  // CHECK USER TODAY SEARCH HISTORY ENDS

  // HANDLE SPOKEN QUERY
  const handleSpokenQuery = (query) => {
    navigate(query);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && searchValue !== "") {
      handleSearch();
    }
  };

  // HANDLE FUNCTION FOR ANALYSING USER INPUT

  const handleInputChange = (e) => {
    const valueData = e.target.value;
    setSearchValue(valueData);
    // analyzeInput(valueData.trim());
  };

  const handleSearch = () => {
    if (
      activeTab === "question" ||
      activeTab === "medical" ||
      activeTab === "physical" ||
      (activeTab === "CPSS" && initialQuestion === "CPSS-A") ||
      (activeTab === "CPSS" && initialQuestion === "CPSS-F") ||
      activeTab === "olq-analysis"
    ) {
      handleSearchResult();
    }
    if (activeTab === "oir") {
      toast.warning("We Launch OIR test feature soon");
    }
    if (activeTab === "link") {
      handleLinkGenrate();
    }
    if (activeTab === "pdf") {
      handlePdfUpload();
    }

    if (activeTab === "pdf_srch") {
      handlePdfSearchQuestion();
    }
  };

  // SPOKEN ENGLISH ENDS

  const [loadingNotes, setLoadingNotes] = useState(false);
  const [bookList, setBookList] = useState([]);

  const fetchBookList = async () => {
    try {
      setLoadingNotes(true);
      const res = await bookService.myAllBookList();
      if (res) {
        setLoadingNotes(false);
        setBookList(res?.data?.books);
      }
    } catch (error) {
      setLoadingNotes(false);
    }
  };

  useEffect(() => {
    if (auth?.user?._id) {
      fetchBookList();
    }
  }, [auth?.user?._id]);

  const [saveValue, setSaveValue] = useState();

  const handleSave = (idx) => {
    setSaveValue(idx);
  };

  const handleMicFunction = () => {
    // const micValue = localStorage.getItem("ssbgptmic");
    // if (micValue === "true") {
    //   localStorage.setItem("ssbgptmic", "false");
    // } else {
    //   localStorage.setItem("ssbgptmic", "true");
    // }
    if (gptMic) {
      setGptMic(false);
    } else {
      setGptMic(true);
      handleVoice();
    }
  };

  const handleSpeakFunction = () => {
    if (gptSpeaker) {
      setGptSpeaker(false);
    } else {
      setGptSpeaker(true);
    }
  };

  // GET type from URL
  const queryParams = new URLSearchParams(location.search);
  const modalType = queryParams.get("type");
  const urlStartType = queryParams.get("startType");
  const urlInitialQuestion = queryParams.get("initialQuestion");
  const isRedirected = queryParams.get("isRedirected");

  useEffect(() => {
    if (activeTab === "question") {
      setCaptainImage(captainAlphaModal);
      if (!isRedirected) {
        navigate("/chat?type=question");
      }
    } else if (activeTab === "Lecturette") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=Lecturette");
    } else if (activeTab === "medical") {
      setCaptainImage(medicalModal);
      if (!isRedirected) {
        navigate("/chat?type=medical");
      }
    } else if (activeTab === "physical") {
      setCaptainImage(physicalModal);
      if (!isRedirected) {
        navigate("/chat?type=physical");
      }
    } else if (activeTab === "spoken-english") {
      setCaptainImage(markModal);
      if (!isRedirected) {
        navigate("/chat?type=spoken-english");
      }
    } else if (activeTab === "oir-test") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=oir-test");
    } else if (activeTab === "group-discussion") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=group-discussion");
    } else if (activeTab === "mock-psychology") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=mock-psychology");
    } else if (activeTab === "mock-PPDT") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=mock-PPDT");
    } else if (activeTab === "ssb-gto") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=ssb-gto");
    } else if (activeTab === "courses") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=courses");
    } else if (activeTab === "olq-analysis") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=olq-analysis");
    } else if (activeTab === "mock-interview") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=mock-interview");
    } else if (activeTab === "current-affair") {
      setCaptainImage(captainAlphaModal);
      navigate("/chat?type=current-affair");
    } else {
      setCaptainImage("");
    }
  }, [activeTab, navigate, isRedirected]);

  // HANDLE MODAL TYPE BY PAGE LINK
  useEffect(() => {
    if (modalType === "question") {
      setCaptainImage(captainAlphaModal);
      handleAskQuestion();
    } else if (modalType === "medical") {
      setCaptainImage(medicalModal);
      handleMedicalQuestion();
    } else if (modalType === "physical") {
      setCaptainImage(physicalModal);
      handlePhysicalQuestion();
    } else if (modalType === "spoken-english") {
      setCaptainImage(markModal);
      handleSpokenEnglish();
    } else if (modalType === "courses") {
      setCaptainImage(captainAlphaModal);
      handleCourses();
    } else if (modalType === "current-affair") {
      setCaptainImage(captainAlphaModal);
      handleCurrentAffair();
    } else {
      setCaptainImage("");
      handleNoCategory();
    }
  }, [modalType]);

  const handleShowClassCategory = () => {
    setShowClassCategory(true);
    setInitialSearchType("");
    setInitialQuestion("");
    setSrchToday(true);
  };

  const handleInitialStartAction = (startType) => {
    // if (startType !== "startCourses") {
    //   setInitialSearchType(startType);
    //   setSrchToday(true);
    //   navigate(`/chat${location.search}&startType=${startType}`);
    // }

    if (startType === "startSpokenEnglish") {
      window.open("/spoken-english", "_blank");
    }
    if (startType === "startCourses") {
      window.open(
        `${process.env.REACT_APP_REDIRECT_LINK}/ssb-courses`,
        "_blank",
        "noopener,noreferrer"
      );
    }

    if (startType === "startCurrentAffairs") {
      setConversationId("");
      setInitialQuestion(startType);
      navigate(`/chat${location.search}&startType=${startType}`);
    }

    if (startType !== "") {
      setShowSearchInput(true);
      handleSearchResult("Jai Hind Sir");
    }
  };

  // CAPTAIN ALPHA/ASK QUESTION INITIAL ACTIONS MESSAGES
  const handleQuestionInitialAction = (searchType) => {
    setConversationId("");
    setInitialQuestion(searchType);
    navigate(`/chat${location.search}&initialQuestion=${searchType}`); // ADD INITIAL QUESTION IN URL
    if (searchType === "option-A") {
      setShowSearchInput(true);
    } else if (searchType === "option-B") {
      setShowSearchInput(true);
    } else if (searchType === "option-C") {
      setShowSearchInput(false);
    } else {
      setShowSearchInput(false);
    }
  };

  useEffect(() => {
    const handleBackNavigation = () => {
      setOutputData([]);
      if (urlInitialQuestion) {
        setInitialQuestion(urlInitialQuestion);
      } else {
        setInitialQuestion("");
      }
      if (urlStartType) {
        setInitialSearchType(urlStartType);
      } else {
        setInitialSearchType("");
        setSrchToday(false);
      }
    };

    // Listen for popstate events
    window.addEventListener("popstate", handleBackNavigation);

    // Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, [urlInitialQuestion, urlStartType]); // Re-run the effect if the pathname changes

  useEffect(() => {
    // if url have iNITIALqUESTION//OPTIONS
    if (urlInitialQuestion) {
      setInitialQuestion(urlInitialQuestion);
    } else {
      setInitialQuestion("");
    }

    // IF URL HAVE STARTtYPE/initialSearchType
    if (urlStartType) {
      setInitialSearchType(urlStartType);
    } else {
      setInitialSearchType("");
      setSrchToday(false);
      setShowSearchInput(false);
    }

    if (urlStartType === "startQuestion") {
      if (urlInitialQuestion === "option-A") {
        setShowSearchInput(true);
        setSrchToday(true);
        setOutputData([]);
      } else if (urlInitialQuestion === "option-B") {
        setShowSearchInput(true);
        setSrchToday(true);
        setOutputData([]);
      } else if (urlInitialQuestion === "option-C") {
        setShowSearchInput(false);
        setSrchToday(true);
        setOutputData([]);
      } else {
        setShowSearchInput(false);
        setSrchToday(true);
        setInitialQuestion("");
        setOutputData([]);
      }
    }
  }, [urlInitialQuestion, urlStartType]);

  const [showChatBox, setShowChatBox] = useState(true);
  const [showBook, setShowBook] = useState(false);

  // SHOW CLASSROOM/CATEGORY PROMPT
  const handleShowClassroom = () => {
    setshowExerciseBar(false);
    setShowChatBox(true);
    setShowBook(false);
    navigate("/chat");
  };

  // SHOW EXERCISE BAR
  const handleShowExercise = () => {
    setshowExerciseBar(true);
    setShowChatBox(false);
    setShowBook(false);
  };

  // SHOW NOTES BAR
  const handleShowNotes = () => {
    setshowExerciseBar(false);
    setShowChatBox(false);
    setShowBook(true);
  };

  const mediaQuery = window.matchMedia("(max-width: 575px)");
  useEffect(() => {
    if (!showExerciseBar && !showChatBox && !showBook) {
      setShowChatBox(true);
    }

    if (mediaQuery.matches && (showChatBox || showBook)) {
      // Disable scrolling
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      // Enable scrolling
      document.body.style.overflow = "";
      document.body.style.position = "";
    }

    // Cleanup when the component is unmounted or state changes
    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
    };
  }, [showExerciseBar, showChatBox, showBook, mediaQuery]);

  const [videoLink, setVideoLink] = useState("");
  const [showDetailVideo, setshowDetailVideo] = useState(false);
  // HANDLE HOW TO USE VIDEO POPUP
  const handleHowToUseVideo = (url) => {
    if (url) {
      setVideoLink(url);
      setshowDetailVideo(true);
    }
  };

  // HANDLE CURRENT AFFAIRS LOGIC  STARTS
  const [currentAffairTypes, setCurrentAffairTypes] = useState("");
  const [currentAffairData, setCurrentAffairData] = useState("");

  const [currentAffairDate, setCurrentAffairDate] = useState("");

  const [addCurrentAffairModal, setAddCurrentAffairModal] = useState(false);
  const [editCurrentAffairModal, setEditCurrentAffairModal] = useState(false);

  useEffect(() => {
    if (urlStartType === "startCurrentAffairs") {
      setShowSearchInput(false);
      setCurrentAffairTypes("currentAffair-A");
      setOutputData([]);
      setPlaceholderInput("");
    }
  }, [urlStartType]);

  const [calenderData, setCalenderData] = useState([]);
  const fetchCurrentaffair = async () => {
    const result = await userService.getAllCurrentAffair();
    if (result?.data?.success) {
      setCalenderData(result?.data?.affairs);
    }
  };
  useEffect(() => {
    fetchCurrentaffair();
  }, []);

  const localStorageToken = localStorage.getItem("ssb-token")
    ? JSON.parse(localStorage.getItem("ssb-token"))
    : "";

  let token = localStorageToken?.token;
  const [currentAffairId, setCurrentAffairId] = useState("");

  const handleDateClick = async (filter) => {
    const date = moment(filter).format("YYYY-MM-DD");
    setCurrentAffairDate(date);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/current-affairs/${date}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        if (auth?.user?.role === "10") {
          setEditCurrentAffairModal(true);
          setCurrentAffairData(response?.data?.currentAffairs?.content);
          setCurrentAffairId(response?.data?.currentAffairs?._id);
          setCurrentAffairDate(
            moment(response?.data?.date).format("YYYY-MM-DD")
          );
        } else {
          const newEntry = {
            question: `Current affairs of ${moment(filter).format(
              "DD/MM/YYYY"
            )}`,
            currentAffair:
              response?.data?.currentAffairs?.content || "No content available",
          };
          setOutputData((prevData) => [...prevData, newEntry]);
          setCurrentAffairTypes("");
        }
      } else {
        if (auth?.user?.role === "10") {
          setAddCurrentAffairModal(true);
        } else {
          showNotification("error", response?.data?.message);
        }
      }
    } catch (error) {
      if (auth?.user?.role === "10") {
        setAddCurrentAffairModal(true);
      } else {
        showNotification("error", "No current affair for the selected date");
      }
    }
  };

  // HANDLE CURRENT AFFAIRS LOGIC  STARTS

  const [currentAffairLoading, setCurrentAffairLoading] = useState(false);

  // HANDLE SAVE NEW CURRENT AFFAIRS BY ADMIN Rahul
  const handleSaveCurrentAffair = async (type) => {
    setCurrentAffairLoading(true);
    const data = {
      content: currentAffairData,
      isActive: type === "no" ? true : false,
      date: currentAffairDate,
    };
    try {
      const result = await userService.createNewCurrentAffairs(data);
      if (result?.data?.success) {
        setCurrentAffairLoading(false);

        showNotification("success", result?.data?.message);
      }
    } catch (error) {
      showNotification("error", error);
      setCurrentAffairLoading(false);
    }
    setAddCurrentAffairModal(false);
    setCurrentAffairData("");
    setCurrentAffairDate("");
    setCurrentAffairTypes("currentAffair-A");
  };

  // HANDLE UPDATE CURRENT AFFAIRS BY ADMIN Rahul
  const handleUpdateCurrentAffair = async (type) => {
    setCurrentAffairLoading(true);

    const data = {
      content: currentAffairData,
      isActive: type === "yes" ? true : false,
      date: currentAffairDate,
    };
    try {
      const result = await userService.updateCurrentAffairs(
        data,
        currentAffairId
      );
      if (result?.data?.success) {
        setCurrentAffairLoading(false);
        showNotification("success", result?.data?.message);
      }
    } catch (error) {
      setCurrentAffairLoading(false);

      showNotification("error", error);
    }
    setCurrentAffairId("");
    setEditCurrentAffairModal(false);
    setCurrentAffairData("");
    setCurrentAffairDate("");
    setCurrentAffairTypes("currentAffair-A");
  };

  return (
    <Fragment>
      {loadingNotes ? (
        <Loader />
      ) : (
        <>
          <CustomHelmet
            title="INET-GPT: Your INET Self Preparation Tool"
            description="Prepare effectively for your SSB/AFSB/NSB/ interview with INET-GPT, a free self-preparation tool."
          />
          <GptLayout>
            <div className="container">
              <section className="gpt_layout_wrapper">
                <GptSidebar showExerciseBar={showExerciseBar} />
                <section
                  className={`gpt_Search_box gpt_seachBox_mobile ${
                    showChatBox ? "showChatBox" : ""
                  }`}
                >
                  <div className="input_box">
                    {/* CHAT HEADER FOR MOBILE SCREEN STRAT */}
                    {modalType && (
                      <GptChatHeader
                        handleSpeakFunction={handleSpeakFunction}
                        captainImage={captainImage}
                        gptSpeaker={gptSpeaker}
                        welcomeText={welcomeText}
                        handleShowExercise={handleShowExercise}
                        handleShowNotes={handleShowNotes}
                      />
                    )}
                    {/* CHAT HEADER FOR MOBILE SCREEN ENDS */}

                    <div className={`srch_output custonScroll`} ref={scrollRef}>
                      {!srchToday && (
                        <div className="wlcm_msg">
                          <div className="modal_text">
                            <img
                              src={
                                welcomeText.logoImg
                                  ? welcomeText.logoImg
                                  : auth?.user?.profile?.url
                                  ? auth?.user?.profile?.url
                                  : auth?.user?.gender === "Male"
                                  ? defaultMale
                                  : auth?.user?.gender === "Female"
                                  ? defaultFemale
                                  : defaultUser
                              }
                              style={{
                                borderRadius: welcomeText.logoImg ? 0 : "50%",
                              }}
                              alt="ssb gpt mobile logo"
                              className="mobile_logo_small"
                            />
                            <h1 className="title">{welcomeText.name}</h1>
                            <p className="tagLine">{welcomeText.tagLine}</p>
                            {isRedirected ? (
                              <p className="description">
                                {welcomeText.redirectDescription}
                              </p>
                            ) : (
                              <p className="description">
                                {welcomeText.description}
                              </p>
                            )}
                            <div className="btn_grp">
                              <CustomButton
                                className="watch_tutorial"
                                title="HOW TO USE"
                                tooltip="HOW TO USE"
                                onClick={() =>
                                  handleHowToUseVideo(welcomeText.tutorialLink)
                                }
                              />
                              {welcomeText.startLink ? (
                                <CustomButton
                                  className="start_chat"
                                  title="START"
                                  tooltip="START CHAT"
                                  onClick={() =>
                                    handleInitialStartAction(
                                      welcomeText.startLink
                                    )
                                  }
                                />
                              ) : (
                                <CustomButton
                                  className="choose_classroom"
                                  title="CHOOSE CLASSROOM"
                                  tooltip="CHOOSE CLASSROOM"
                                  onClick={handleShowClassCategory}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {showClassCategory && (
                        <div className="choose_category_wrapper">
                          <div className="title">Choose Classroom</div>
                          <ul>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "question" ? "active" : ""
                                }`}
                                onClick={() => handleAskQuestion()}
                              >
                                <img src={ndaMentorIcon} alt="ndaMentorIcon" />
                                <p>Inet Mentor</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "physical" ? "active" : ""
                                }`}
                                onClick={() => handlePhysicalQuestion()}
                              >
                                <img src={trainer} alt="trainer" />
                                <p>Fitness Trainer</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "medical" ? "active" : ""
                                }`}
                                onClick={() => handleMedicalQuestion()}
                              >
                                <img src={doctor} alt="doctor" />
                                <p>Medical Officer</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que${activeTab === "general-science"
                                  ? "active"
                                  : ""
                                  }`}
                                onClick={() => handleGeneralScience()}
                              >
                                <img
                                  src={generalStudyIcon}
                                  alt="generalStudyIcon"
                                />
                                <p>General Science</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "reasoning" ? "active" : ""
                                }`}
                                onClick={() => handleReasoning()}
                              >
                                <img src={reasoningicon} alt="mathIcon" />
                                <p>Reasoning</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que${
                                  activeTab === "history" ? "active" : ""
                                }`}
                                onClick={() => handleHistory()}
                              >
                                <img src={historyIcon} alt="historyIcon" />
                                <p>History</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que${
                                  activeTab === "geography" ? "active" : ""
                                }`}
                                onClick={() => handleGeography()}
                              >
                                <img src={geogrophyIcon} alt="geogrophyIcon" />
                                <p>Geography</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "reasoning" ? "active" : ""
                                }`}
                                onClick={() => handleReasoning()}
                              >
                                <img src={reasoningicon} alt="mathIcon" />
                                <p>Reasoning</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "maths" ? "active" : ""
                                }`}
                                onClick={() => handleMaths()}
                              >
                                <img src={mathIcon} alt="mathIcon" />
                                <p>Maths</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "english" ? "active" : ""
                                }`}
                                onClick={() => handleEnglish()}
                              >
                                <img src={englishIcon} alt="englishIcon" />
                                <p>English</p>
                              </button>
                            </li>
                            <li>
                              <button className="media_select ask_que">
                                <img src={SSBMentorIcon} alt="SSBMentorIcon" />
                                <p>SSB-GPT</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "courses" ? "active" : ""
                                }`}
                                onClick={() => handleCourses()}
                              >
                                <img src={courses} alt="courses" />
                                <p>Courses</p>
                              </button>
                            </li>

                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "current-affair" ? "active" : ""
                                }`}
                                onClick={() => handleCurrentAffair()}
                              >
                                <img src={currentAffair} alt="currentAffair" />
                                <p>Current Affairs</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "spoken-english" ? "active" : ""
                                }`}
                                onClick={() => handleSpokenEnglish()}
                              >
                                <img src={spokenEnglish} alt="spokenEnglish" />
                                <p>Spoken English</p>
                              </button>
                            </li>
                            <li>
                              <button
                                className={`media_select ask_que ${
                                  activeTab === "polity" ? "active" : ""
                                }`}
                                onClick={() => handlePolity()}
                              >
                                <img src={polity} alt="polity" />
                                <p>Polity</p>
                              </button>
                            </li>
                          </ul>
                        </div>
                      )}

                      {/* CAPTAIN ALPHA CATEGORISED QUESTIONS START */}
                      {initialSearchType === "startQuestion" && (
                        <div className="answer_box">
                          <div className="profile_img">
                            <img
                              className="captainProfilePic"
                              src={homeBanner}
                              alt="captain modal"
                            />
                          </div>{" "}
                          <div>
                            <div className="output_box">
                              <div className="arrowTri"></div>
                              {initialQuestion === "" && (
                                <p>
                                  Jai Hind! I am Captain Alpha, your dedicated
                                  AI expert for NDA interview preparation,
                                  trained by experienced ex-SSB/AFSB/NSB
                                  officers. You can rely on me to guide you
                                  through your journey. Please choose the role
                                  you'd like me to play:
                                </p>
                              )}

                              {initialQuestion === "option-A" ? (
                                <p>
                                  Alright, Alpha Warrior. I'm ready. How can I
                                  assist you today?
                                </p>
                              ) : initialQuestion === "option-B" ? (
                                <p>
                                  Excellent choice, Alpha Warrior! Let's dive
                                  into analyzing your personality and
                                  Officer-Like Qualities (OLQs). I'll use a mix
                                  of psychometric multiple-choice questions and
                                  some casual conversation to get a better
                                  understanding. Rest assured, everything
                                  between us is completely private—only you and
                                  I will see this. Shall we start?
                                </p>
                              ) : (
                                initialQuestion === "option-C" && (
                                  <>
                                    <p>
                                      If you choose Option A, I'll provide
                                      answers to general queries about the SSB
                                      interview process. This is a great option
                                      if you're looking to gather information
                                      about the interview, for example, what is
                                      PGT (Progressive Group Task).
                                    </p>
                                    <p>
                                      However, if you're seeking personalized
                                      guidance—then Option B would be the better
                                      choice. With Option B, I'll take the time
                                      to understand your situation more closely
                                      and give tailored advice based on your
                                      needs.
                                    </p>
                                    <p>
                                      As your personal mentor, I will thoroughly
                                      analyze every aspect of your personality
                                      using psychometric tests, situational
                                      questions, and casual interactions. I will
                                      assess your physical stamina through
                                      activities like running, exercising, or
                                      cycling. Additionally, I will ask
                                      miscellaneous questions to better
                                      understand you as an individual. Based on
                                      this, I will create a personalized
                                      roadmap.
                                    </p>
                                    <p>
                                      Our daily interactions will include
                                      psychology tests, which I will analyze and
                                      provide feedback on to help you improve.
                                      We will conduct mock interviews, followed
                                      by detailed feedback and guidance for
                                      improvement. We will also have unlimited
                                      group discussions or casual conversations
                                      to enhance your communication skills. I'll
                                      ensure you're well-versed in military
                                      awareness, current affairs, and prescribe
                                      exercises to boost your stamina in a short
                                      period.
                                    </p>
                                    <p>
                                      If you have any medical concerns, I will
                                      refer you to retired military doctors for
                                      expert advice. In short, everything
                                      required to prepare you for the SSB
                                      interview will be taken care of by me. You
                                      won’t need to go elsewhere or attend
                                      additional classes—I will be your mentor,
                                      guiding you through all aspects of the SSB
                                      interview preparation. So tell me which
                                      option you want to choose.
                                    </p>
                                  </>
                                )
                              )}
                              <div className="action_btn_grp">
                                {initialQuestion === "" && (
                                  <>
                                    <button
                                      onClick={() =>
                                        handleQuestionInitialAction("option-A")
                                      }
                                    >
                                      (A) Answer my Questions
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleQuestionInitialAction("option-B")
                                      }
                                    >
                                      (B) Become my Personal Mentor{" "}
                                      <b>[Recommended]</b>
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleQuestionInitialAction("option-C")
                                      }
                                    >
                                      (C) Explain the difference between (A) &
                                      (B) to help you make an informed choice.
                                    </button>
                                  </>
                                )}
                                {initialQuestion === "option-C" && (
                                  <>
                                    <button
                                      onClick={() =>
                                        handleQuestionInitialAction("option-A")
                                      }
                                    >
                                      (A) Answer my Questions
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleQuestionInitialAction("option-B")
                                      }
                                    >
                                      (B) Become my Personal Mentor{" "}
                                      <b>[Recommended]</b>
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* CAPTAIN ALPHA CATEGORISED QUESTIONS ENDS */}

                      {/* CURRENT AFFAIR CALENDER STARTS */}
                      {initialSearchType === "startCurrentAffairs" &&
                        currentAffairTypes === "currentAffair-A" && (
                          <CustomCalendar
                            calenderData={calenderData}
                            handleDateClick={handleDateClick}
                          />
                        )}
                      {/* CURRENT AFFAIRS CALENDER ENDS */}

                      {/* SEARCH HISORTY AND ASK QUESTION BOX  */}
                      {outputData?.length > 0 &&
                        outputData?.map((ele, idx) => (
                          <>
                            {ele?.question && (
                              <h5 className="gpt_questions" key={idx}>
                                <div className="question_text">
                                  {ele?.question}{" "}
                                  <div className="arrowTri"></div>{" "}
                                </div>
                                <div className="profile_img">
                                  <img
                                    src={
                                      auth?.user?.gender === "Male"
                                        ? defaultMale
                                        : auth?.user?.gender === "Female"
                                        ? defaultFemale
                                        : defaultUser
                                    }
                                    alt="ssb gpt user"
                                    className="captainProfilePic"
                                  />
                                </div>{" "}
                              </h5>
                            )}
                            {ele?.srtList?.length > 0 && (
                              <h5>
                                {ele?.srtList?.map((itm, id) => (
                                  <span key={id}>
                                    {id + 1}. {itm}
                                  </span>
                                ))}
                              </h5>
                            )}
                            {ele?.currentAffair && (
                              <div className="answer_box">
                                <div
                                  className="profile_img"
                                  onClick={handleSpeakFunction}
                                >
                                  <img
                                    className="captainProfilePic"
                                    src={homeBanner}
                                    alt="captain modal"
                                  />
                                  <button>
                                    {gptSpeaker ? (
                                      <img
                                        src={profile_mic_active}
                                        alt="speaker function"
                                        className="mic_btn active"
                                      />
                                    ) : (
                                      <img
                                        src={profile_mic}
                                        alt="speaker function"
                                        className="mic_btn"
                                      />
                                    )}
                                  </button>
                                </div>{" "}
                                <div>
                                  <div className="output_box">
                                    <div className="arrowTri"></div>
                                    {ele?.spokenType?.length > 0 &&
                                      ele?.spokenType?.map((itm, id) => (
                                        <button
                                          key={id}
                                          onClick={() =>
                                            handleSpokenQuery(itm?.query)
                                          }
                                        >
                                          {itm?.type}
                                        </button>
                                      ))}

                                    <div
                                      className="current_affair"
                                      dangerouslySetInnerHTML={{
                                        __html: ele.currentAffair,
                                      }}
                                    />
                                  </div>
                                  <div className="action_btn">
                                    {/* <button
          className="stop_video"
          title="Disable Video suggestion"
          onClick={() => handleDisableVideo()}
        >
          {disableVideo ? (
            <CiVideoOff />
          ) : (
            <CiVideoOn />
          )}
        </button> */}
                                    <span onClick={() => handleSave(idx)}>
                                      <LuBookmark />
                                      Save
                                    </span>
                                    <span>
                                      <AiFillDislike />
                                    </span>
                                    <span>
                                      <AiFillLike />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}

                            {(ele?.answer || ele?.spokenType?.length > 0) && (
                              <div className="answer_box">
                                <div
                                  className="profile_img"
                                  onClick={handleSpeakFunction}
                                >
                                  <img
                                    className="captainProfilePic"
                                    src={homeBanner}
                                    alt="captain modal"
                                  />
                                  <button>
                                    {gptSpeaker ? (
                                      <img
                                        src={profile_mic_active}
                                        alt="speaker function"
                                        className="mic_btn active"
                                      />
                                    ) : (
                                      <img
                                        src={profile_mic}
                                        alt="speaker function"
                                        className="mic_btn"
                                      />
                                    )}
                                  </button>
                                </div>{" "}
                                <div>
                                  <div className="output_box">
                                    <div className="arrowTri"></div>
                                    {ele?.spokenType?.length > 0 &&
                                      ele?.spokenType?.map((itm, id) => (
                                        <button
                                          key={id}
                                          onClick={() =>
                                            handleSpokenQuery(itm?.query)
                                          }
                                        >
                                          {itm?.type}
                                        </button>
                                      ))}

                                    <div className="video_data">
                                      <div className="video_content" key={idx}>
                                        {ele?.title !== "" && (
                                          <p>{ele?.title}</p>
                                        )}
                                        {ele?.url && ele?.url !== null && (
                                          <div className="thumbnail-container">
                                            <iframe
                                              className="thumbnail"
                                              src={ele?.url}
                                              title={ele?.url}
                                              frameBorder="0"
                                              allowFullScreen
                                            />
                                            <div
                                              className="overlay"
                                              onClick={() =>
                                                handleVideoView(ele?.url)
                                              }
                                            >
                                              <BsPlayCircle />
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {ele?.answer !== "" ? (
                                      <>
                                        {ele?.answer?.Title && (
                                          <p>
                                            <strong>Title :</strong>
                                            <span>{ele?.answer?.Title}</span>
                                          </p>
                                        )}
                                        {ele?.answer?.Content && (
                                          <p>
                                            <strong>Content :</strong>
                                            <span>{ele?.answer?.Content}</span>
                                          </p>
                                        )}
                                        {ele?.answer?.Summary && (
                                          <p>
                                            <strong>Summary :</strong>
                                            <span>{ele?.answer?.Summary}</span>
                                          </p>
                                        )}
                                        {!ele?.answer?.Title &&
                                          !ele?.answer?.Content &&
                                          !ele?.answer?.Summary && (
                                            <p>
                                              <ReactMarkdown>
                                                {ele?.answer}
                                              </ReactMarkdown>
                                            </p>
                                          )}
                                      </>
                                    ) : (
                                      <div className="video_data">
                                        <div
                                          className="video_content"
                                          key={idx}
                                        >
                                          {ele?.title !== "" && (
                                            <p>{ele?.title}</p>
                                          )}
                                          {ele?.url === "Loading..." ? (
                                            <p>{ele?.url}</p>
                                          ) : (
                                            <div
                                              className="thumbnail"
                                              onClick={() =>
                                                handleVideoView(ele?.url)
                                              }
                                            >
                                              <img
                                                src={logo_mobile}
                                                alt="thumbnail"
                                              />
                                              <span>
                                                <BsPlayCircle />
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="action_btn">
                                    <span onClick={() => handleSave(idx)}>
                                      <LuBookmark />
                                      Save
                                    </span>
                                    <span>
                                      <AiFillDislike />
                                    </span>
                                    <span>
                                      <AiFillLike />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ))}

                      {/* SEARCH HISTORY AND ASK QUESTION BOX ENDS */}

                      <div className="tour_msg"></div>
                      {/* HANLDE TAT LOGICS STARTS  */}

                      {isLoading && activeTab === "video" && (
                        <div className="search_loader">
                          <img src={loaderGif} alt="loader" />
                        </div>
                      )}

                      {/* {activity === "pushUps" && (
                  <PushupTracker
                    setPushupCount={setPushupCount}
                    setActivity={setActivity}
                    setActivityStatus={setActivityStatus}
                  />
                )} */}
                    </div>

                    {showSearchInput && (
                      <div className="srch_input">
                        {/* SEARCH INPUT AND CATEGORIES START */}
                        <div>
                          <button
                            className="search"
                            onClick={(e) => handleMediaOpen(e)}
                          >
                            {mediaOpen ? (
                              <img src={choiceOrange} alt="choiceOrange" />
                            ) : (
                              <img src={choiceBlue} alt="choiceOrange" />
                            )}
                          </button>
                          {activeTab === "pdf" && (
                            <div
                              className="upload_box"
                              style={{
                                border: activeinput ? "1px solid #fff" : "",
                              }}
                            >
                              <input
                                type="file"
                                accept="*/.pdf"
                                onFocus={() => {
                                  setMediaOpen(false);
                                }}
                                onChange={(e) => handleMediaChange(e)}
                                placeholder={placeHolderInput}
                              />
                              <button
                                className="media_btn"
                                onClick={() => handleSearch()}
                              >
                                {isLoading ? <LuLoader /> : <TiArrowUp />}
                              </button>
                            </div>
                          )}

                          {activeTab !== "pdf" &&
                            initialQuestion !== "CPSS-F" &&
                            activeTab !== "olq-analysis" && (
                              <input
                                type="text"
                                value={searchValue}
                                style={{
                                  border: activeinput ? "1px solid #fff" : "",
                                }}
                                onChange={(e) => handleInputChange(e)}
                                onFocus={() => {
                                  setMediaOpen(false);
                                }}
                                onKeyDown={handleKeyDown}
                                placeholder={placeHolderInput}
                              />
                            )}

                          {/* OPTION INPUT BOX TYPE */}
                          {(initialQuestion === "CPSS-F" ||
                            activeTab === "olq-analysis") && (
                            <div className="option_bordered_sec">
                              <div className="optionSec">
                                <button
                                  title="A"
                                  onClick={() => handleSearchResult("", "A")}
                                >
                                  A
                                </button>
                                <button
                                  title="B"
                                  onClick={() => handleSearchResult("", "B")}
                                >
                                  B
                                </button>
                                <button
                                  title="C"
                                  onClick={() => handleSearchResult("", "C")}
                                >
                                  C
                                </button>
                                <button
                                  title="B"
                                  onClick={() => handleSearchResult("", "D")}
                                >
                                  D
                                </button>
                              </div>
                              <div className="nextSec">
                                <button
                                  title="Next/Skip"
                                  onClick={() => handleSearchResult("", "Skip")}
                                >
                                  Skip
                                </button>
                              </div>
                            </div>
                          )}

                          <div className="media_wrapper">
                            <div
                              className={`media_drop_up ${
                                mediaOpen ? "media_drop_up_on" : ""
                              }`}
                            >
                              <ul>
                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "question" ? "active" : ""
                                    }`}
                                    onClick={() => handleAskQuestion()}
                                  >
                                    <img
                                      src={ndaMentorIcon}
                                      alt="ndaMentorIcon"
                                    />
                                    <p>CDS Mentor</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "physical" ? "active" : ""
                                    }`}
                                    onClick={() => handlePhysicalQuestion()}
                                  >
                                    <img src={trainer} alt="trainer" />
                                    <p>Fitness Trainer</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "medical" ? "active" : ""
                                    }`}
                                    onClick={() => handleMedicalQuestion()}
                                  >
                                    <img src={doctor} alt="doctor" />
                                    <p>Medical Officer</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que${activeTab === "general-science"
                                      ? "active"
                                      : ""
                                      }`}
                                    onClick={() => handleGeneralScience()}
                                  >
                                    <img
                                      src={generalStudyIcon}
                                      alt="generalStudyIcon"
                                    />
                                    <p>General Science</p>
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className={`media_select ask_que${
                                      activeTab === "history" ? "active" : ""
                                    }`}
                                    onClick={() => handleHistory()}
                                  >
                                    <img src={historyIcon} alt="historyIcon" />
                                    <p>History</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que${
                                      activeTab === "geography" ? "active" : ""
                                    }`}
                                    onClick={() => handleGeography()}
                                  >
                                    <img
                                      src={geogrophyIcon}
                                      alt="geogrophyIcon"
                                    />
                                    <p>Geography</p>
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "maths" ? "active" : ""
                                    }`}
                                    onClick={() => handleMaths()}
                                  >
                                    <img src={mathIcon} alt="mathIcon" />
                                    <p>Maths</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "english" ? "active" : ""
                                    }`}
                                    onClick={() => handleEnglish()}
                                  >
                                    <img src={englishIcon} alt="englishIcon" />
                                    <p>English</p>
                                  </button>
                                </li>
                                <li>
                                  <button className="media_select ask_que">
                                    <img
                                      src={SSBMentorIcon}
                                      alt="SSBMentorIcon"
                                    />
                                    <p>SSB-GPT</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "courses" ? "active" : ""
                                    }`}
                                    onClick={() => handleCourses()}
                                  >
                                    <img src={courses} alt="courses" />
                                    <p>Courses</p>
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className={`media_select ask_que ${activeTab === "current-affair"
                                      ? "active"
                                      : ""
                                      }`}
                                    onClick={() => handleCurrentAffair()}
                                  >
                                    <img
                                      src={currentAffair}
                                      alt="currentAffair"
                                    />
                                    <p>Current Affairs</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que ${activeTab === "spoken-english"
                                      ? "active"
                                      : ""
                                      }`}
                                    onClick={() => handleSpokenEnglish()}
                                  >
                                    <img
                                      src={spokenEnglish}
                                      alt="spokenEnglish"
                                    />
                                    <p>Spoken English</p>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className={`media_select ask_que ${
                                      activeTab === "polity" ? "active" : ""
                                    }`}
                                    onClick={() => handlePolity()}
                                  >
                                    <img src={polity} alt="polity" />
                                    <p>Polity</p>
                                  </button>
                                </li>
                              </ul>
                            </div>

                            {searchValue === "" ? (
                              <button
                                className="media_btn"
                                onClick={() => handleVoice()}
                              >
                                {isListening ? (
                                  <RiVoiceprintFill />
                                ) : (
                                  <AiFillAudio />
                                )}
                              </button>
                            ) : (
                              <button
                                className="media_btn"
                                onClick={() => handleSearch()}
                              >
                                {isLoading ? (
                                  <LuLoader />
                                ) : (
                                  <HiOutlinePaperAirplane />
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                        {/* SEARCH INPUT AND CATEGORIES ENDS */}

                        {/* <p className="advice_txt">
                    Read our <Link to="/term-of-use">Terms</Link> and{" "}
                    <Link to="/privacy-policies">Privacy Policy</Link>.
                  </p> */}
                      </div>
                    )}
                  </div>
                </section>

                {/* VIDEO POPUP START */}
                <VideoPopup
                  videoLink={videoLink}
                  showDetailVideo={showDetailVideo}
                  setshowDetailVideo={setshowDetailVideo}
                />
                {/* VIDEO POPUP ENDS */}

                <CustomModal
                  show={addCurrentAffairModal}
                  setShow={() => setAddCurrentAffairModal(false)}
                  height="90vh"
                  width="90%"
                >
                  <div className="saveVideoModal currentAffairs">
                    <div className="title">Add New Current Affairs</div>

                    <label style={{ marginBottom: "8px" }}>
                      Current Affair Content :
                    </label>
                    <ReactQuill
                      modules={modules}
                      formats={formats}
                      value={currentAffairData}
                      onChange={(e) => setCurrentAffairData(e)}
                      style={{ marginBottom: "12px" }}
                    />

                    <div className="save_btn">
                      <CustomButton
                        onClick={() => handleSaveCurrentAffair("no")}
                        className="modal_savebtn"
                        title={"Draft"}
                      />
                      <CustomButton
                        onClick={() => handleSaveCurrentAffair("yes")}
                        className="modal_savebtn"
                        title={
                          currentAffairLoading ? <ButtonLoader /> : "Publish"
                        }
                      />
                    </div>
                  </div>
                </CustomModal>

                {/* EDIT MODAL FOR CURRENT AFFAIRS  */}

                <CustomModal
                  show={editCurrentAffairModal}
                  setShow={() => setEditCurrentAffairModal(false)}
                  height="90vh"
                  width="90%"
                >
                  <div className="saveVideoModal currentAffairs">
                    <div className="title">Edit Current Affairs</div>

                    <label style={{ marginBottom: "8px" }}>
                      Current Affair Content :
                    </label>

                    <ReactQuill
                      modules={modules}
                      formats={formats}
                      value={currentAffairData}
                      onChange={(e) => setCurrentAffairData(e)}
                      style={{ marginBottom: "12px" }}
                    />
                    <div className="save_btn">
                      <CustomButton
                        onClick={() => handleUpdateCurrentAffair("no")}
                        className="modal_savebtn"
                        title={"Draft"}
                      />
                      <CustomButton
                        onClick={() => handleUpdateCurrentAffair("yes")}
                        className="modal_savebtn"
                        title={
                          currentAffairLoading ? <ButtonLoader /> : "Publish"
                        }
                      />
                    </div>
                  </div>
                </CustomModal>

                <GptBooks
                  bookList={bookList}
                  fetchBookList={fetchBookList}
                  handleSave={saveValue}
                  outputData={outputData}
                  // activeTab={activeTab}
                  questionList={questionList}
                  handleShowHistory={handleShowHistory}
                  activeCaptain={activeTab}
                  handleMicFunction={handleMicFunction}
                  handleSpeakFunction={handleSpeakFunction}
                  gptMic={gptMic}
                  gptSpeaker={gptSpeaker}
                  loadingNotes={loadingNotes}
                  handleShowClassroom={handleShowClassroom}
                  handleShowExercise={handleShowExercise}
                  showBook={showBook}
                  setShowBook={setShowBook}
                  handleShowNotes={handleShowNotes}
                  showExerciseBar={showExerciseBar}
                  showChatBox={showChatBox}
                />
              </section>
              <WhatCanDo />
            </div>
          </GptLayout>
        </>
      )}
    </Fragment>
  );
};

export default GptSearch;
